






































































// vue
import { defineComponent, ref, Ref } from '@vue/composition-api'

// componnents
import { PageHeader, AccordionFilters } from '@/components'
import { DataTable } from '@/components/table'

// services
import { BondControlService } from '@/services/dailyControl'

// types
import { Paginator } from '@/models'
import { BondControlMassive, FiltersBondControlList } from '@/models/dailyControl/BondControlModel'

// utils
import { loading, dateLibs, alerts } from '@/utils'

export default defineComponent({
  name: 'BondControlMassiveList',
  components: {
    PageHeader,
    AccordionFilters,
    DataTable
  },
  setup () {
    const title = ref('CONTROL DE BONOS MASIVO')
    const loadingItems = ref(false)
    const years = dateLibs.createRangeYears()
    const months = dateLibs.getAllMonths()
    const fortnights = dateLibs.fortnightsDefault
    const breadcrumbs = [
      {
        text: 'Dashboard'
      },
      {
        text: 'Control de Bonos Masivo',
        active: true
      }
    ]
    const fields = [
      {
        key: 'headquarter.name',
        label: 'Sede'
      },
      {
        key: 'area.name',
        label: 'Área'
      },
      {
        key: 'sub_area.name',
        label: 'Sub Área'
      },
      {
        key: 'year',
        label: 'Año'
      },
      {
        key: 'month',
        label: 'Mes',
        formatter: (value) => months.find(m => Number(m.value) === Number(value))?.text
      },
      {
        key: 'fortnight',
        label: 'Quincena',
        formatter: (value) => fortnights.find(f => Number(f.value) === Number(value))?.text
      },
      {
        key: 'bondType.name',
        label: 'Tipo de Bono'
      },
      {
        key: 'actions',
        label: ''
      }
    ]

    const pagination: Ref<Paginator> = ref({
      currentPage: 1,
      total: 0,
      count: 0,
      perPage: 25
    })

    const filters: Ref<FiltersBondControlList> = ref({
      headquarter: null,
      area: null,
      sub_area: null,
      year: null,
      month: null,
      fortnight: null,
      loaded_massive: true,
      bond_types: [],
      employees: []
    })

    const items: Ref<BondControlMassive[]> = ref([])

    const getBondControls = async () => {
      loading('show')
      loadingItems.value = true
      const result = await BondControlService.getMassiveWithPagination(pagination.value.perPage, pagination.value.currentPage, filters.value)
      pagination.value = {
        ...result.pagination
      }
      items.value = result.objects
      loading('hide')
      loadingItems.value = false
    }
    getBondControls()

    const changePerPage = (perPage: number) => {
      pagination.value.perPage = perPage
      if (perPage * pagination.value.currentPage > pagination.value.total) {
        pagination.value.currentPage = 1
      }
      getBondControls()
    }

    const changePage = (page: number) => {
      pagination.value.currentPage = page
      getBondControls()
    }

    const deleteItem = async (item: BondControlMassive) => {
      const msg = 'Seguro que desea eliminar el ítem selecionado}.'
      const confirm = await alerts.confirm(msg)
      if (confirm) {
        loading('show')
        await BondControlService.deleteMassive(
          item.headquarter_id,
          item.area_id,
          item.sub_area_id,
          item.fortnight,
          item.year,
          item.month,
          true
        )
        loading('hide')
        alerts.success()
        getBondControls()
      }
    }

    return {
      title,
      breadcrumbs,
      loadingItems,
      items,
      pagination,
      fields,
      changePage,
      changePerPage,
      fortnights,
      years,
      months,
      deleteItem
    }
  }
})
